import Logger from '../util/Logger';
import { printApi } from './api';
import _ from 'lodash';
import DateTime from '../models/DateTime';

const getPdfId = (result) => {
  return _.get(result, 'id') || null;
};

const generatePdf = (slug, breakAvoids, breakBefores) => {
  return Promise.resolve().then(() => {
    if (!slug) {
      Logger.info('reject generatePdf()');
      throw Error('Must pass a slug as a param');
    } else {
      Logger.info('resolve generatePdf()');
      const url = encodeURIComponent(
        `/r/q/${slug}/answers?tz=${DateTime.getCurrentTimeZone()}&avoids=${breakAvoids.join(
          ',')}&befores=${breakBefores.join(',')}`);
      return printApi.post(`/?url=${url}`, { url });
    }
  });
};

const getPdfStatus = (id) => {
  return Promise.resolve().then(() => {
    if (!id) {
      Logger.info('reject getPdfStatus()');
      throw Error('Must pass id');
    } else {
      return printApi.get(`/?id=${id}`);
    }
  });
};

const watchPdfStatus = (originalResult) => {
  return new Promise((resolve, reject) => {
    const originalId = getPdfId(originalResult);

    const watch = (id) => {
      getPdfStatus(id)
        .then(result => {
          if (!!result.url) {
            Logger.info('Pdf status watcher: Success');
            clearInterval(intervalId);
            resolve(result.url);
          }
        })
        .catch(error => {
          Logger.info('Pdf status watcher: Error');
          clearInterval(intervalId);
          reject(error);
        });
    };

    // Every 5 seconds, query about the roster status
    const intervalId = setInterval(() => {
      watch(originalId);
    }, 1000);

    // Instant query as well.
    watch(originalId);
  });
};

export const pdfApi = {

  fetchPdf: (slug, breakAvoids, breakBefores) => {
    return generatePdf(slug, breakAvoids, breakBefores)
      .then(result => watchPdfStatus(result));
  }
};
